import styled from "styled-components";
import Address from "./address";
import ContactInformation from "./contact";
import PersonalInformation from "./personal";
import EducationInformation from './education';
import VisaInformation from './visa';
import PassportInformation from './passport'
import DriversLicenseformation from "./driverslicense";
import AdditionalInformation from "./additionalinfo";

const Wrapper = styled.div`
    font-size: 13px;
`;

const Personal = ({ person, refreshEmployeeInfo, disabled }: any) => {

    return (
        <Wrapper>
            <div className='row'>
                <div className='col-md-6' style={{ paddingRight: '7.5px' }}>
                    <PersonalInformation person={person} refreshEmployeeInfo={refreshEmployeeInfo} disabled={disabled} />
                </div>
                <div className='col-md-6' style={{ paddingLeft: '7.5px' }}>
                    <Address person={person} disabled={disabled} />
                </div>
                <div className='col-md-12'>
                    <ContactInformation person={person} refreshEmployeeInfo={refreshEmployeeInfo} disabled={disabled} />
                </div>
                <div className='col-md-12'>
                    <EducationInformation person={person} disabled={disabled} />
                </div>
                <div className='col-md-12'>
                    <VisaInformation person={person} disabled={disabled} />
                </div>
                <div className='col-md-12'>
                    <PassportInformation person={person} disabled={disabled} />
                </div>
                <div className='col-md-12'>
                    <DriversLicenseformation person={person} disabled={disabled} />
                </div>
                <div className='col-md-12'>
                    <AdditionalInformation person={person} disabled={disabled} />
                </div>
            </div>
        </Wrapper>
    );
};

export default Personal;
